const $html = document.documentElement;
import { loc } from '../lib/_location.js';
import { load } from '../lib/_load.js';
const brandJsonUrl = "/assets/json/brand.json";
class Modal {
	constructor( $dom ){
		this.dom = $dom;
		this.data = [];
		this.id = $dom.getAttribute("id");
		//console.log(`%cModal START > ${this.id}`, "color: #00afb9");
		this.currentID = "";
		let $this = this;
		load.getJson(brandJsonUrl).then( (res) =>{
			$this.data = res;
			$this.checkParam();
			$this.nav();
		});
	}
	nav(){
		let $modalBtns = document.querySelectorAll("[data-modal]");
		let $closeBtns = document.querySelectorAll("[data-close-drawer]");
		const eventListenersMultiple = [
			{ elements: $modalBtns, type: "click", handler: this.getURL.bind(this) },
			{ elements: $closeBtns, type: "click", handler: this.closeToChangeURL.bind(this) }
		];
		eventListenersMultiple.forEach( ( el ) => {
			el.elements.forEach( ( element )=> {
				element.removeEventListener(el.type, el.handler, false);
				element.addEventListener(el.type, el.handler, false);
			});
		});
	}
	getURL(e){
		e.preventDefault();
		let link = e.currentTarget.getAttribute("href");
		this.changeURL(link);
	}
	closeToChangeURL(){ //CLOSE
		history.replaceState({}, '', './');
		this.checkParam();
	}
	changeURL( newURL ){
		history.replaceState({}, '', newURL);
		this.checkParam();
	}
	checkParam(){
		let info = loc.all();
		if( info.params.brand ){
			this.getContent( info.params.brand );
		}else{
			this.close();
		}
	}
	
	getContent( brand ){
		//console.log("getcontent: ", brand);
		//console.log(this.data)
		let $this = this;
		let brandData = this.data.find(item => item.id === brand);
		//console.log(brandData);
		this.dom.querySelector("h2").innerHTML = brandData.name;
		if( brandData.image ){
			this.dom.querySelector(".drawer-header figure").innerHTML = `<img src="${brandData.image.url}?w=320" width="${brandData.image.width}" height="${brandData.image.height}">`;
		}else{
			this.dom.querySelector(".drawer-header figure").innerHTML = `<img src="https://images.microcms-assets.io/assets/720bb66a2e0d4fccb99c3e1a4b342790/b88cbbbac9044f77a0212bbfd98e3ffa/blank_our-experience.jpg?f=webp&w=312" width="156" height="156" alt="no image">`;
		}
		
		let offices = "";
		//console.log(brandData.offices);
		document.querySelector(".c-drawer .c-num span.n").innerHTML = brandData.offices.length;
		brandData.offices.forEach( (o, index) => {
			let officeImg = o.image;
			let imgHTML = "";
			if( officeImg ){
				imgHTML = `<img src="${o.image.url}?w=312" width="156" height="104" alt="${o.base_name}">`
			}else{
				imgHTML = `<img src="https://images.microcms-assets.io/assets/720bb66a2e0d4fccb99c3e1a4b342790/5fc3f870f9a24e8686be1e1446f9eac2/blank_about-locations.jpg?f=webp&w=312" alt="${o.name}" width="156" height="104">`
			}
			let link = "";
			if( o.url != "" ){
				link = `<p class="avenir link"><a href="${o.url}" target="_blank">${o.url}</a></p>`;
			}
			console.log(link, o.url)
			offices += `<li class="office-item" data-area="" data-category="">
							<div class="c-cols">
								<div class="cols_l">
									<div class="c-name">
										<p>${o.name}</p>
										<h3>${o.base_name}</h3>
									</div>
									<div class="c-location">
										<p class="avenir">〒${o.zipcode}</p>
										<p class="address">${o.address}</p>
										<p class="avenir">${o.tel}</p>
										${link}
									</div>
								</div>
								<div class="cols_r">
									<figure>
										${imgHTML}
									</figure>
								</div>
							</div>
						</li>`;
		});
		this.dom.querySelector(".c-list_office ul").innerHTML = offices;
		setTimeout(function(){
			$this.open();
		}, 300);
	}
	open(){
		if( !$html.classList.contains("show-drawer" ) ){
			$html.classList.add("show-drawer");
		}
		//modal.lenis.stop();
	}
	close(){
		if( $html.classList.contains("show-drawer" ) ){
			$html.classList.remove("show-drawer");
		}
		//modal.lenis.start();
	}
}
export let modal = {
	lenis: null,
	target: null,
	init: function( lenis ){
		modal.lenis = lenis;
		let $modal = document.querySelector(".c-drawer");
		if( $modal ){
			modal.target = new Modal( $modal );
		}
	}
}